import styled from 'styled-components';
import colors from '../../style/colors';
import { variants } from './style';

interface ProgressbarProps {
  value: number;
  variant?: keyof typeof variants;
}

export interface VerticalProgressBarProps {
  variant?: keyof typeof variants;
  value: number;
  id?: string;
  'aria-label'?: string;
  'aria-describedby'?: string;
  'aria-hidden'?: boolean;
}

const ProgressbarBackground = styled.div<VerticalProgressBarProps>`
  display: flex;
  flex-direction: column-reverse;
  background-color: ${colors.gray400};
  height: 16px;
  width: 8px;
  border-radius: 1px;
`;

const Progressbar = styled.div<ProgressbarProps>`
  ${props => (props.variant ? variants[props.variant] : variants['action'])};
  height: ${props => `${props.value}%`};
  width: 8px;
  border-bottom-left-radius: 1px;
  border-bottom-right-radius: 1px;
`;

const VerticalProgressBar = (props: VerticalProgressBarProps) => {
  const { value, variant, 'aria-label': ariaLabel, id } = props;
  return (
    <ProgressbarBackground
      aria-label={ariaLabel}
      id={id}
      aria-valuenow={value}
      role="progressbar"
      {...props}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <Progressbar value={value} variant={variant} />
    </ProgressbarBackground>
  );
};

export default VerticalProgressBar;
